import { useEffect, useRef, useState } from 'react'

import { DSAlert } from '@vr/ds-react'

import { CollectList } from '@/compositions/collect-list'
import { FormFilter } from '@/compositions/form-filters-collect'
import { FormFilterRef } from '@/compositions/form-filters-collect/ref'
import { useCollectContext } from '@/contexts/collect.context'

const CollectView = () => {
  const [pendingCount, setPendingCount] = useState(0)
  const filterFormRef = useRef<FormFilterRef>(null)

  const { tableData, setTableData, handleFilter, setPage, setResults, handleLimitChange, limit } = useCollectContext()

  useEffect(() => {
    const total = getRejectedCount()
    setPendingCount(total)
  }, [tableData])

  const getRejectedCount = () => {
    return tableData?.filter(item => item.status === 'recusado').length ?? 0
  }

  const handleClearForm = () => {
    if (filterFormRef.current) {
      filterFormRef.current.clearForm()
      setTableData([])
      setResults(0)
      setPage(1)
      handleLimitChange(10)
    }
  }

  return (
    <>
      {pendingCount > 0 && (
        <DSAlert
          type='warning'
          title={`${pendingCount} agrupamento${
            pendingCount > 1 ? 's' : ''
          } pendente${pendingCount > 1 ? 's' : ''} de vínculo`}
          css={{ marginBottom: '$sm16' }}
        >
          Vincule o{pendingCount > 1 && 's'} cart
          {pendingCount > 1 ? 'ões' : 'ão'} ao{pendingCount > 1 && 's'}{' '}
          colaborador{pendingCount > 1 && 'es'} para avançar com a solicitação
          de entrega
        </DSAlert>
      )}
      <FormFilter
        ref={filterFormRef}
        onFilters={handleFilter}
        onClear={handleClearForm}
        limit={limit}
        onLimitChange={handleLimitChange}
      />

      <CollectList />
    </>
  )
}

export default CollectView
